var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M0.723424 7.00019C0.723424 3.53471 3.53275 0.725377 6.99824 0.725377C10.4637 0.725377 13.2731 3.53471 13.2731 7.00019C13.2731 10.4657 10.4637 13.275 6.99824 13.275C3.53275 13.275 0.723424 10.4657 0.723424 7.00019ZM6.99824 0.275391C3.28423 0.275391 0.273438 3.28619 0.273438 7.00019C0.273438 10.7142 3.28423 13.725 6.99824 13.725C10.7122 13.725 13.723 10.7142 13.723 7.00019C13.723 3.28619 10.7122 0.275391 6.99824 0.275391ZM10.8217 5.0595C10.9348 4.9385 10.9285 4.74866 10.8075 4.63548C10.6865 4.52229 10.4967 4.52863 10.3835 4.64963L6.12119 9.20629L4.11401 7.04619C4.00123 6.92482 3.8114 6.91785 3.69003 7.03063C3.56865 7.14341 3.56169 7.33323 3.67447 7.45461L5.90069 9.85044C5.95733 9.9114 6.03675 9.94609 6.11996 9.94623C6.20317 9.94637 6.2827 9.91194 6.33955 9.85117L10.8217 5.0595Z",
          fill: "currentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }